import React from 'react'
import Flex from 'shared/library/atoms/Flex'
import { Text } from 'library/atoms/Typography'
import {
  StyleGuideMain,
  StyleGuideIdProps
} from 'shared/library/pages/StyleGuide'

const exampleDivs = (
  <>
    <div style={{ background: 'gray', padding: '20px' }}>1st</div>
    <div style={{ background: 'lightgray', padding: '20px' }}>2nd</div>
    <div style={{ background: 'gray', padding: '20px' }}>3nd</div>
  </>
)

const PROPS = {
  Description: () => (
    <Text as="div">
      <p>
        The Flex component aims to provide an efficient way to layout, align and
        distribute space among items in a container. It uses the styled-system
        to take all the props for{' '}
        <a
          title="flexbox"
          target="_blank"
          rel="noopener noreferrer"
          href="https://styled-system.com/table/#flexbox"
        >
          flexbox
        </a>
        ,{' '}
        <a
          title="space"
          target="_blank"
          rel="noopener noreferrer"
          href="https://styled-system.com/table/#space"
        >
          space
        </a>
        , width, minWidth and maxWidth.
      </p>
    </Text>
  ),
  examples: [
    {
      title: 'Flex',
      code: `<Flex flexWrap="wrap" width="100%">
  <Flex justifyContent="center" width="100%" gap={3}>
    {exampleDivs}
  </Flex>
  <Flex justifyContent="space-between" width="100%" mt={10}>
    {exampleDivs}
  </Flex>
</Flex>
    `,
      scope: { Flex, exampleDivs }
    }
  ]
}

const FlexStyleGuide = (props: StyleGuideIdProps) => (
  <StyleGuideMain {...props} {...PROPS} />
)

export default FlexStyleGuide
